import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';

export type MeetingIssueType =
  | 'no_attendance_recorded'
  | 'nothing_recorded'
  | 'transcription_stuck'
  | 'no_transcript'
  | 'ai_feedback_failed'
  | 'ai_feedback_missing'
  | 'not_linked_to_session'
  | 'webhook_failures'
  | 'client_errors'
  | 'silent_participant_audio'
  | 'recorder_problem';

export type MeetingIssueSeverity = 'critical' | 'warning' | 'info';

export type MeetingIssueDTO = {
  type: MeetingIssueType;
  severity: MeetingIssueSeverity;
  label: string;
  detail?: string;
};

export type MeetingIssueRowDTO = {
  meetingId: string;
  sessionId?: string;
  enrollmentId?: string;
  scheduledDate: string;
  endTime?: string;
  durationMinutes?: number;
  title: string;
  mentor?: { _id: string; name: string };
  students: { _id: string; name: string }[];
  issues: MeetingIssueDTO[];
};

export type MeetingIssuesFilters = {
  days?: number;
};

export const getMeetingIssues: ApiDescription = {
  endpoint: '/admin/meeting-issues',
  method: RequestsMethod.Get,
};

export type GetMeetingIssues = ApiData<
  MeetingIssuesFilters,
  {
    meetings: MeetingIssueRowDTO[];
    scanned: number;
    from: string;
    to: string;
  }
>;

export type MeetingClientErrorDTO = {
  _id: string;
  at: string;
  username?: string;
  errorType?: string;
  errorMessage?: string;
  stackTrace?: string;
};

export type MeetingFailedEventDTO = {
  _id: string;
  at: string;
  env: string;
  eventType: string;
  retryCount: number;
  lastAttemptedAt?: string;
  errors: string[];
};

export type MeetingErrorDetailsDTO = {
  clientErrors: MeetingClientErrorDTO[];
  failedEvents: MeetingFailedEventDTO[];
};

export const getMeetingErrorDetails: ApiDescription = {
  endpoint: '/admin/meeting-issues/:id',
  method: RequestsMethod.Get,
};

export type GetMeetingErrorDetails = ApiData<never, MeetingErrorDetailsDTO>;
